import React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fillOpacity: ".3",
  d: "M22 8V2L2 22h16V8h4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14 22V10L2 22h12zm6-12v8h2v-8h-2zm0 12h2v-2h-2v2z"
})), 'SignalCellularConnectedNoInternet2BarSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/SignalCellularConnectedNoInternet2BarSharp.js
// module id = 6176
// module chunks = 2